import { format, parseISO } from "date-fns";

export const getEmailCorrespondenceSubject = (email: any) => {
  const subjectWithoutStatementsAndExpressions =
    email?.emailSent?.subjectWithoutStatementsAndExpressions ||
    "Geen onderwerp";
  const createdAt = email?.emailSent?.createdAt || "-";

  try {
    const formattedDate = format(parseISO(createdAt), "dd-MM-yyyy HH:mm");
    return `${formattedDate} - ${subjectWithoutStatementsAndExpressions}`;
  } catch {
    return `${createdAt} - ${subjectWithoutStatementsAndExpressions}`;
  }
};
